import Swiper from 'swiper';
import { Autoplay, EffectFade, Navigation, Pagination } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/effect-fade';

(function (Drupal) {
  Drupal.behaviors.flexiBuildSlideshows = {
    attach: function (context, settings) {
      once('flexi-build-slideshow', '.swiper').forEach(slideshowElement => {
        const slideshowData = JSON.parse(slideshowElement.dataset.swiper);

        const slidesPerView = slideshowData.effect === 'fade' ? 1 : slideshowData.slidesPerView;

        const slideshow = new Swiper(slideshowElement, {
          modules: [Autoplay, Navigation, Pagination, EffectFade],
          loop: true,
          autoplay: slideshowData.autoplay == true ? {
            delay: Number(slideshowData.delay)
          } : false,
          simulateTouch: true, // Ensure touch simulation is enabled
          touchEventsTarget: 'wrapper', // Ensure touch events target is correct
          touchRatio: 1,
          touchAngle: 45,
          grabCursor: true,
          slidesPerView: slideshowData.mobileSlidesPerView,
          slidesPerGroup: 1,
          spaceBetween: Number(slideshowData.spaceBetween),
          speed: Number(slideshowData.speed),
          observeParents: true,
          observer: true,
          navigation: slideshowData.navigation !== "none" && slideshowData.navigation !== null ? {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
          } : false,
          pagination: slideshowData.pagination !== 0 && slideshowData.pagination !== null ? {
            el: '.swiper-pagination',
            type: 'bullets',
            clickable: true,
            renderBullet: function (index, className) {
              return `<span class="swiper-pagination-bullet" tabindex="0" role="button" aria-label="Go to slide ${index + 1}"></span>`;
            },
          } : false,
          effect: slideshowData?.effect ? slideshowData.effect : 'slide',
          fadeEffect: { crossFade: true },
          breakpoints: {
            [slideshowData.mobileBreapoint]: {
              slidesPerView: slideshowData.effect === 'fade' ? 1 : slideshowData.mobileSlidesPerView,
              slidesPerGroup: 1,
            },
            [slideshowData.tabletBreapoint]: {
              slidesPerView: slideshowData.effect === 'fade' ? 1 : slideshowData.tabletSlidesPerView,
              slidesPerGroup: 1,
            },
            [slideshowData.desktopBreapoint]: {
              slidesPerView: slideshowData.effect === 'fade' ? 1 : slideshowData.desktopSlidesPerView,
              slidesPerGroup: 1,
            },
          },
          on: {
            init: function () {
              // Remove the loading class to show the slideshow
              const slidePlaceholder = document.querySelector(".swiper-placeholder");
              if (slidePlaceholder) slidePlaceholder.remove();
              slideshowElement.classList.remove('swiper-loading');

              const nextButton = document.querySelector('.swiper-button-next');
              const prevButton = document.querySelector('.swiper-button-prev');
              if (nextButton) nextButton.setAttribute('tabindex', '0');
              if (prevButton) prevButton.setAttribute('tabindex', '0');

              const addKeydownListeners = () => {
                document.querySelectorAll('.swiper-pagination-bullet').forEach(bullet => {
                  bullet.addEventListener('keydown', function(event) {
                    if (event.key === 'Enter' || event.key === ' ') {
                      event.preventDefault();
                      bullet.click();
                    }
                  });
                });
              };

              const observer = new MutationObserver(() => {
                addKeydownListeners();
              });

              observer.observe(slideshowElement, { childList: true, subtree: true });

              addKeydownListeners();

              [nextButton, prevButton].forEach(button => {
                if (button) {
                  button.addEventListener('keydown', function(event) {
                    if (event.key === 'Enter' || event.key === ' ') {
                      event.preventDefault();
                      button.click();
                    }
                  });
                }
              });
            },
          },
        });

        // Ensure touch events are not blocked
        slideshowElement.style.touchAction = 'manipulation';
        slideshowElement.style.userSelect = 'none';
      });
    }
  };
})(Drupal);
